import { apiRequest } from './helpers';
import { buildUrl } from '../lib/route.utils';
import { ALL_PAGESIZE } from '../constants/admin/settings';
import { omit } from 'lodash';
import { CONTRACT_TYPES, VALUE_ALL } from '../constants/settings';

export const organizations = {
    get: urlParams => apiRequest('GET', buildUrl('/organizations', urlParams), {}),
    delete: id => apiRequest('DELETE', `/organizations/${id}`, {}),
    create: data => apiRequest('POST', '/organizations', { body: data }),
    update: (id, data) => apiRequest('PUT', `/organizations/${id}`, { body: data }),
    getMember: id => apiRequest('GET', `/organizations/${id}`, {})
};

export const events = {
    get: urlParams => apiRequest('GET', buildUrl('/events', urlParams), {}),
    senderPost: (id, body) => apiRequest('POST', `/events/${id}/senders`, { body }),
    getSenders: id => apiRequest('GET', `/events/${id}/senders`, {}),
    getAll: type => apiRequest('GET', `/events?pagesize=${ALL_PAGESIZE}${type ? `&type=${type}` : ''}`, {}),
    getTimetable: eventId => apiRequest('GET', `/events/${eventId}/timetable`, {}),
    update: (id, data) => apiRequest('PUT', `/events/${id}`, { body: data }),
    getMember: id => apiRequest('GET', `/events/${id}`, {}),
    create: data => apiRequest('POST', '/events', { body: data }),
    delete: id => apiRequest('DELETE', `/events/${id}`, {}),
    getOrg: (id, urlParams) => apiRequest('GET', buildUrl(`/events?organizationId=${id}`, urlParams), {}),
    getOrgAll: (id, type) =>
        apiRequest('GET', `/events?organizationId=${id}&pagesize=${ALL_PAGESIZE}${type ? `&type=${type}` : ''}`, {}),
    getEmails: (eventId, type) => apiRequest('GET', `/events/${eventId}/emails?type=${type}`, {}),
    putEmail: (id, eventId, body) => apiRequest('PUT', `/events/${eventId}/emails/${id}`, { body }),
    getReminders: eventId => apiRequest('GET', `/events/${eventId}/reminders`, {}),
    getReminder: (eventId, id) => apiRequest('GET', `/events/${eventId}/reminders/${id}`, {}),
    updateReminder: (eventId, id, body) => apiRequest('PUT', `/events/${eventId}/reminders/${id}`, { body }),
    createReminder: (eventId, body) => apiRequest('POST', `/events/${eventId}/reminders`, { body }),
    removeReminder: (eventId, id) => apiRequest('DELETE', `/events/${eventId}/reminders/${id}`, {})
};

export const contacts = {
    getOrgAll: id => apiRequest('GET', `/users?organizationId=${id}&pagesize=${ALL_PAGESIZE}`, {}),
    get: urlParams => apiRequest('GET', buildUrl('/users', urlParams), {}),
    getAll: () => apiRequest('GET', `/users?pagesize=${ALL_PAGESIZE}`, {}),
    getMember: (id, orgId) => apiRequest('GET', `/users/${id}?organizationId=${orgId}`, {}),
    getRoles: id => apiRequest('GET', `/users/${id}/roles`, {}),
    create: body => apiRequest('POST', '/users', { body }),
    getOrg: (id, urlParams) => apiRequest('GET', buildUrl(`/users?organizationId=${id}`, urlParams), {}),
    update: (id, body, orgId) => apiRequest('PUT', `/users/${id}${orgId ? `?organizationId=${orgId}` : ''}`, { body }),
    delete: id => apiRequest('DELETE', `/users/${id}`, {})
};

export const partners = {
    sendMessage: (eventId, partners, subject, text) =>
        apiRequest('POST', `/events/${eventId}/messages`, { body: { partners, subject, text } }),
    get: urlParams => apiRequest('GET', buildUrl('/partners', urlParams), {}),
    getAllForEvent: (eventId, orgId) =>
        apiRequest(
            'GET',
            `/partners?eventId=${eventId}&pagesize=${ALL_PAGESIZE}${orgId ? `&organizationId=${orgId}` : ''}`,
            {}
        ),
    copyClearance: (from, to, eventId) =>
        apiRequest('POST', `/partners/${from}/clearances?eventId=${eventId}`, { body: { to } }),
    getAll: () => apiRequest('GET', `/partners?pagesize=${ALL_PAGESIZE}`, {}),
    getUsers: (id, urlParams) => apiRequest('GET', buildUrl(`/users?partnerId=${id}`, urlParams), {}),
    getOrgUsers: (id, orgId, urlParams) =>
        apiRequest('GET', buildUrl(`/users?partnerId=${id}&organizationId=${orgId}`, urlParams), {}),
    delete: id => apiRequest('DELETE', `/partners/${id}`, {}),
    create: data => apiRequest('POST', '/partners', { body: data }),
    update: (id, data, orgId) =>
        apiRequest('PUT', `/partners/${id}${orgId ? `?organizationId=${orgId}` : ''}`, {
            body: data
        }),
    getMember: (id, orgId) => apiRequest('GET', `/partners/${id}${orgId ? `?organizationId=${orgId}` : ''}`, {}),
    getOrg: (id, urlParams) => apiRequest('GET', buildUrl(`/partners?organizationId=${id}`, urlParams), {}),
    getOrgAll: id => apiRequest('GET', `/partners?organizationId=${id}&pagesize=${ALL_PAGESIZE}`, {}),
    getForEvent: (eventId, urlParams, orgId) =>
        apiRequest(
            'GET',
            buildUrl(`/partners?eventId=${eventId}${orgId ? `&organizationId=${orgId}` : ''}`, urlParams),
            {}
        )
};

export const roles = {
    getAll: () => apiRequest('GET', '/lists/roles')
};

export const artists = {
    get: urlParams => apiRequest('GET', buildUrl('/artists', urlParams), {}),
    getForEvent: (eventId, orgId, urlParams, contract) =>
        apiRequest(
            'GET',
            buildUrl(
                `/artists?eventId=${eventId}${orgId ? `&organizationId=${orgId}` : ''}${
                    contract ? `&includeContracts=${contract}` : ''
                }`,
                urlParams
            ),
            {}
        ),
    getOrgAll: id => apiRequest('GET', `/artists?organizationId=${id}&pagesize=${ALL_PAGESIZE}`, {}),
    getEventAll: (eventId, orgId) =>
        apiRequest(
            'GET',
            `/artists?eventId=${eventId}&pagesize=${ALL_PAGESIZE}${orgId ? `&organizationId=${orgId}` : ''}`,
            {}
        ),
    getMember: (id, orgId) => apiRequest('GET', `/artists/${id}${orgId ? `?organizationId=${orgId}` : ''}`, {}),
    create: data => apiRequest('POST', '/artists', { body: data }),
    update: (id, data, orgId) =>
        apiRequest('PUT', `/artists/${id}${orgId ? `?organizationId=${orgId}` : ''}`, { body: data }),
    delete: id => apiRequest('DELETE', `/artists/${id}`, {}),
    getUsers: (id, urlParams) => apiRequest('GET', buildUrl(`/users?artistId=${id}`, urlParams), {}),
    getOrgUsers: (id, orgId, urlParams) =>
        apiRequest('GET', buildUrl(`/users?artistId=${id}&organizationId=${orgId}`, urlParams), {}),
    getAllUsers: id => apiRequest('GET', `/users?artistId=${id}&pagesize=${ALL_PAGESIZE}`, {}),
    getAllOrgUsers: (id, orgId) =>
        apiRequest('GET', `/users?artistId=${id}&organizationId=${orgId}&pagesize=${ALL_PAGESIZE}`, {}),
    getAll: () => apiRequest('GET', `/artists?pagesize=${ALL_PAGESIZE}`, {}),
    getOrg: (id, urlParams) => apiRequest('GET', buildUrl(`/artists?organizationId=${id}`, urlParams), {})
};

export const contracts = {
    sendReminder: (contracts, comments) => apiRequest('POST', `/contracts/reminder`, { body: { contracts, comments } }),
    post: body => apiRequest('POST', '/contracts', { body }),
    createVersion: (id, body) => apiRequest('POST', `/contracts/${id}/versions`, { body }),
    put: (id, body) => apiRequest('PUT', `/contracts/${id}`, { body: omit(body, 'type') }),
    getMember: id => apiRequest('GET', `/contracts/${id}`, {}),
    getAllVersions: id => apiRequest('GET', `/contracts/${id}/versions?order=-createdAt&pagesize=${ALL_PAGESIZE}`, {}),
    getSigners: (artist, orgId, contractType) =>
        apiRequest(
            'GET',
            `/users?contractType=${contractType}&artistId=${artist}&pagesize=${ALL_PAGESIZE}${
                orgId ? `&organizationId=${orgId}` : ''
            }`
        ),
    upload: (id, body) => apiRequest('POST', `/contracts/${id}/upload`, { body }),
    get: (urlParams, filters = {}, type) =>
        apiRequest(
            'GET',
            buildUrl(
                `/contracts?archived=false&type=${type || CONTRACT_TYPES.CLEARANCE}${
                    filters.event && filters.event !== VALUE_ALL ? `&events=${filters.event}` : ''
                }${filters.status && filters.status !== VALUE_ALL ? `&status=${filters.status}` : ''}`,
                urlParams
            ),
            {}
        ),
    getOrg: (id, urlParams, filters = {}, type) =>
        apiRequest(
            'GET',
            buildUrl(
                `/contracts?organizationId=${id}&archived=false&type=${type || CONTRACT_TYPES.CLEARANCE}${
                    filters.event && filters.event !== VALUE_ALL ? `&events=${filters.event}` : ''
                }${filters.status && filters.status !== VALUE_ALL ? `&status=${filters.status}` : ''}`,
                urlParams
            ),
            {}
        ),
    getArchived: urlParams => apiRequest('GET', buildUrl('/contracts?archived=true', urlParams), {}),
    getOrgArchived: (id, urlParams) =>
        apiRequest('GET', buildUrl(`/contracts?archived=true&organizationId=${id}`, urlParams), {}),
    delete: id => apiRequest('DELETE', `/contracts/${id}`, {}),
    getForEventAndArtist: (eventId, artistId, orgId) =>
        apiRequest(
            'GET',
            `/contracts?eventId=${eventId}&organizationId=${orgId}&artistId=${artistId}&pagesize=${ALL_PAGESIZE}&type=${CONTRACT_TYPES.CLEARANCE}`
        )
};

export const templates = {
    get: urlParams => apiRequest('GET', buildUrl('/templates', urlParams), {}),
    getAll: () => apiRequest('GET', `/templates?pagesize=${ALL_PAGESIZE}`, {}),
    getOrgAll: id => apiRequest('GET', `/templates?organizationId=${id}&pagesize=${ALL_PAGESIZE}`, {}),
    getOrg: (id, urlParams) => apiRequest('GET', buildUrl(`/templates?organizationId=${id}`, urlParams), {}),
    getMember: id => apiRequest('GET', `/templates/${id}`, {}),
    create: data => apiRequest('POST', '/templates', { body: data }),
    update: (id, data) => apiRequest('PUT', `/templates/${id}`, { body: data }),
    delete: id => apiRequest('DELETE', `/templates/${id}`, {})
};

export const stages = {
    getAllForEvent: eventId => apiRequest('GET', `/events/${eventId}/stages?pagesize=${ALL_PAGESIZE}`, {}),
    post: (eventId, body) => apiRequest('POST', `/events/${eventId}/stages`, { body }),
    put: (eventId, stageId, body) => apiRequest('PUT', `/events/${eventId}/stages/${stageId}`, { body }),
    delete: (eventId, stageId) => apiRequest('DELETE', `/events/${eventId}/stages/${stageId}`, {})
};

export const performances = {
    post: body => apiRequest('POST', '/performances', { body }),
    put: (id, body) => apiRequest('PUT', `/performances/${id}`, { body }),
    delete: id => apiRequest('DELETE', `/performances/${id}`, {}),
    getAllForArtist: (eventId, artistId, orgId) =>
        apiRequest(
            'GET',
            `/performances?${
                orgId ? `&organizationId=${orgId}` : ''
            }eventId=${eventId}&artistId=${artistId}&pagesize=${ALL_PAGESIZE}`,
            {}
        )
};



// WEBPACK FOOTER //
// ./src/services/api.admin.js